export default "__VITE_ASSET__B5Xv094s__"